import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow",
  "use": "icon-down-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down-arrow\"><path fill=\"#319E55\" d=\"M820.48 317.867a34.133 34.133 0 1 1 48.213 48.213L536.747 698.027a34.133 34.133 0 0 1-48.214 0l-331.52-331.52a34.133 34.133 0 1 1 48.214-48.64L512 625.92z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol